import { pdpSharedNotificationMultiplePdpVisitsModalConfig as pdpSharedMultiplePdpVisitsModalConfig } from './PdpSharedNotificationMultiplePdpVisitsModal/pdpSharedNotificationMultiplePdpVisitsModalConfig';
import { pdpSharedNotificationPdpSourcingModalConfig as pdpSharedSourcingModalConfig } from './PdpSharedNotificationPdpSourcingModal/pdpSharedNotificationPdpSourcingModalConfig';

export const pdpSharedNotifications = [
    pdpSharedMultiplePdpVisitsModalConfig,
    pdpSharedSourcingModalConfig,
];
